module.exports = __webpack_public_path__ + "static/media/Mesa-doble.5fbfb197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-doble.jpg
// module id = 144
// module chunks = 0